// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"zk_a bag_ti bag_a bag_q bag_k","AdSlotMail__mail--notLoaded":"zk_b bag_eu bag_bj bag_tx","show-ad-not-loaded":"zk_c","AdSlotMail__cta":"zk_e"};